import React, { useState, useEffect } from 'react';
import CategoryCard from '../components/CategoryCard';
import CategoryForm from '../components/CategoryForm';
import styles from '../styles/Category.module.css';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { getData,putData, postData, postFormData,deleteData } from '../ServerRequest.js';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  minWidth: 350,
  maxWidth: 400,
  width: '90%',
};

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await getData('/api/product/categories/?company_id=1');
      console.log('API categories response:', res);
      // Fix: categories are inside res.data.categories
      const apiCategories = res.data && Array.isArray(res.data.categories) ? res.data.categories : [];
      if (apiCategories.length > 0) {
        const mapped = apiCategories.map(cat => ({
          id: cat.id,
          category: cat.category,
          icon: '',
          active: cat.status, // Use backend status directly
          status: cat.status,
          company: cat.company
        }));
        console.log('Mapped categories:', mapped);
        setCategories(mapped);
      } else {
        setCategories([]);
      }
    } catch (err) {
      console.error('Failed to fetch categories:', err);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);

  const handleAdd = () => {
    setEditing(null);
    setShowForm(true);
  };

  const handleEdit = (category) => {
    setEditing(category);
    setShowForm(true);
  };

 const handleDelete = async (id) => {
  if (window.confirm('Delete this category?')) {
    try {
      const res = await deleteData(`/api/product/categories/${id}/?company_id=1`);
      if (res.code === 200 && res.data && res.data.message) {
        setCategories(categories.filter(c => c.id !== id));
        alert(res.data.message);
      } else {
        alert((res.data && res.data.message) || 'Failed to delete category');
      }
    } catch (error) {
      alert('Failed to delete category');
    }
  }
};
  const handleToggle = (id) => {
    setCategories(categories.map(c => c.id === id ? { ...c, active: !c.active } : c));
  };

  const handleFormSubmit = async (form) => {
    // Validate category name
    if (!form.name || form.name.trim() === '') {
      alert('Category name is required');
      return;
    }
    // If editing, update category via PUT API
    if (editing) {
      try {
        const payload = {
          category: form.name,
          status: form.status === 'Active' || form.status === true
        };
        const res = await putData(`/api/product/categories/${editing.id}/?company_id=1`, payload);
        if (res.code === 200 && res.data && res.data.message) {
          const updatedCat = res.data.category;
          setCategories(categories.map(c => c.id === editing.id ? {
            id: updatedCat.id,
            category: updatedCat.category,
            icon: c.icon,
            active: !!updatedCat.status,
            company: updatedCat.company
          } : c));
          alert(res.data.message);
          setShowForm(false);
          setEditing(null);
        } else {
          alert(res.data?.message || 'Failed to update category');
        }
      } catch (err) {
        alert('Failed to update category');
        console.error('Exception:', err);
      }
      return;
    }
    // Add category via API (JSON payload)
    try {
      const payload = {
        category: form.name,
        status: true
      };
      const res = await postData('/api/product/categories/?company_id=1', payload);
      console.log('API response:', res);
      if (res.code === 201 || res.code === 200 || res.category) {
        const newCat = res.category || res.data?.category || { ...form, id: Date.now(), active: true };
        setCategories([...categories, {
          id: newCat.id,
          category: newCat.category,
          icon: '',
          active: !!newCat.status,
          company: newCat.company
        }]);
        alert('Category added!');
        setShowForm(false);
        setEditing(null);
      } else {
        alert(res.message || 'Failed to add category');
        console.error('API error:', res);
      }
    } catch (err) {
      alert('Failed to add category');
      console.error('Exception:', err);
    }
  };

  return (
    <div className={styles.categoriesContainer}>
      <div className={styles.headerRow}>
        <h2>Categories ({categories.length})</h2>
        <button className={styles.addBtn} onClick={handleAdd}>Add Categories</button>
      </div>
      <Modal open={showForm} onClose={() => { setShowForm(false); setEditing(null); }}>
        
        <Box sx={modalStyle}>
          <CategoryForm
            onSubmit={handleFormSubmit}
            onCancel={() => { setShowForm(false); setEditing(null); }}
            editingCategory={editing}
          />
        </Box>
      </Modal>
      <div className={styles.grid}>
        {loading ? (
          <div className={styles.spinnerWrapper}>
            <div className={styles.spinner}></div>
            <div className={styles.spinnerText}>Loading categories...</div>
          </div>
        ) : categories.length === 0 ? (
          <div style={{ padding: '2rem', textAlign: 'center', color: '#888' }}>No categories found.</div>
        ) : (
          categories.map(category => (
            <CategoryCard
              key={category.id}
              category={category}
              name={category.category}
              active={category.active}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onToggle={handleToggle}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Categories;